export enum ExtraExerciseStatus {
    Available = 1,
    WaitingCorrection,
    Corrected,
    Expired,
    Soon,
    InProgress
}
